import {
  useEffect, useMemo, useRef, useState 
} from 'react';
import useSWR from 'swr';

import keycloakService from '../../keycloak_service';
import { sinatraOrigin } from '../../config';

const CLIENT_DETAILS_KEY = 'wallaroo__clientDetails';

const fetchFromSinatra = (sinatraEndpoint = '') => fetch(
  `${sinatraOrigin}/${sinatraEndpoint}`,
  { headers: { Authorization: keycloakService.getAuthHeader() } }
).then(response => response.json())

const useClientDetails = () => {
  const errorTimeoutRef = useRef(null);
  const [errorMessage, setError] = useState(null);

  const { data: clientDetails, error } = useSWR('client_details', fetchFromSinatra)

  const cachedClientDetails = useMemo(() => {
    const cachedClientDetailsString = localStorage.getItem(CLIENT_DETAILS_KEY);
    if (!cachedClientDetailsString) {
      return null;
    }
    return JSON.parse(cachedClientDetailsString);
  }, []);

  useEffect(() => {
    if (clientDetails) {
      localStorage.setItem(CLIENT_DETAILS_KEY, JSON.stringify(clientDetails));
    }
  }, [clientDetails]);

  useEffect(() => {
    if (error) {
      errorTimeoutRef.current = setTimeout(() => {
        setError(error?.message);
      }, 1500);
    } else {
      clearTimeout(errorTimeoutRef.current);
      setError(null);
    }

    return () => {
      clearTimeout(errorTimeoutRef.current);
      setError(null);
    }
  }, [error]);

  return {
    clientDetails: clientDetails || cachedClientDetails,
    error: errorMessage,
  };
};
export default useClientDetails;
